<template>
  <div class="">
    <router-link
      class="btn dealers_btn mr-3"
      :to="{
        name: 'companyDashboard',
        query: { companyId: data.id, support: true },
      }"
      style="font-size: 15px"
      v-if="data.companyType == 'EPUMP'"
    >
      <i class="fa fa-eye mr-2"></i>
      {{$t('text.clickButtons.companyDetails')}}
    </router-link>
    <router-link
      class="btn dealers_btn mr-3"
      :to="{
        name: 'industrial_admin_dashboard',
        query: { companyID: data.id, support: true },
      }"
      style="font-size: 15px"
      v-if="data.companyType == 'GENSYS'"
    >
      <i class="fa fa-eye mr-2"></i>
     {{$t('text.clickButtons.gensysDetails')}}
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
};
</script>
